export enum MenuItem {
    Borrow = <any>'BORROW',
    Invest = <any>'INVEST',
    MyLoans = <any>'MY LOANS',
    MyInvestments = <any>'MY INVESTMENTS',
    Login = <any>'LOGIN'
}
